import { ApiTranslation } from '@/client/components/api-translation';
import useLocale from '@/client/hooks/use-locale';
import { pickLocaleText } from '@/client/utils/i18n-content';

// Renders a per-locale market title. When a stored translation exists for the
// active locale, show it verbatim (zero API cost, client-reviewed). Otherwise
// fall back to the default text via ApiTranslation (on-demand machine
// translation for tenants that have a translate key configured).
export function LocalizedText({ i18n, children }: { i18n?: Record<string, string>; children: string }) {
  const { locale } = useLocale();
  const localized = pickLocaleText(i18n, locale);
  if (localized) return <>{localized}</>;
  return <ApiTranslation>{children}</ApiTranslation>;
}
